module.exports = __webpack_public_path__ + "img/product-shot_04.4203aa18.jpg";